import React from 'react';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const ChequeDetailReportTable = ({
  chequeDetailReportData
}: {
  chequeDetailReportData: any;
}) => {
  const uniqueKeys = tableColumnUtils.extractUniqueKeys(chequeDetailReportData);
  const dynamicColumns: GridColDef[] =
    tableColumnUtils.createColumnsFromKeys(uniqueKeys);
  
  const columnsToDisplay: GridColDef[] =
    tableColumnUtils.getColumnsToDisplay(dynamicColumns);
  
  return (
    <PageWrapper>
      <DataGrid
        rowHeight={50}
        rows={chequeDetailReportData}
        columns={columnsToDisplay}
        getRowId={(row) => row['Sr. No.']}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default ChequeDetailReportTable;
